import { ref } from 'vue'

/**
 * Qiankun 相关类型定义
 */
interface QiankunWindow extends Window {
  __POWERED_BY_QIANKUN__?: boolean
  __INJECTED_PROPS__?: QiankunProps
  __INJECTED_PUBLIC_PATH_BY_QIANKUN__?: string
}

interface QiankunProps {
  isAdmin?: boolean
  websocket?: {
    addMessageHandler: (handler: (event: MessageEvent) => void) => () => void
  }
  [key: string]: any
}

/**
 * Qiankun 功能 composable
 */
export default function useQiankun() {
  const isQiankun = ref<boolean>(!!(window as QiankunWindow).__POWERED_BY_QIANKUN__)
  const isAdmin = ref<boolean>(false)
  let wsCleanup: (() => void) | null = null

  // 获取 qiankun props
  const getQiankunProps = (): QiankunProps | null => {
    const win = window as QiankunWindow
    return win.__INJECTED_PROPS__ || null
  }

  // 初始化管理员状态
  const initAdminStatus = () => {
    const props = getQiankunProps()
    if (props) {
      isAdmin.value = props.isAdmin || false
    }
  }

  // 初始化 WebSocket 监听
  const initWebsocket = (messageHandler?: (data: any) => void) => {
    if (!isQiankun.value) {
      return
    }

    const props = getQiankunProps()
    if (props?.websocket?.addMessageHandler) {
      wsCleanup = props.websocket.addMessageHandler((event: MessageEvent) => {
        try {
          const data = JSON.parse(event.data)
          if (messageHandler) {
            messageHandler(data)
          }
        } catch (error) {
          console.error('[Qiankun] WebSocket消息解析失败:', error)
        }
      })
    }
  }

  // 清理 WebSocket 监听
  const cleanupWebsocket = () => {
    if (wsCleanup) {
      wsCleanup()
      wsCleanup = null
    }
  }

  return {
    isQiankun,
    isAdmin,
    getQiankunProps,
    initAdminStatus,
    initWebsocket,
    cleanupWebsocket
  }
}

